import React, { useEffect, useState } from 'react';
import type { InputNumberProps } from 'antd';
import * as S from './styles';

type ValueType = any | null;

interface StepInputProps extends InputNumberProps {
	min: number;
	max: number;
	step?: number;
	value?: number;
	onChange?: (value: ValueType | null) => void;
}

export function StepInput({ min, max, step = 1, value, onChange, ...props }: Readonly<StepInputProps>): JSX.Element {
	const [internalValue, setInternalValue] = useState<number>(value ?? min);

	useEffect(() => {
		if (typeof value === 'number') {
			setInternalValue(value);
		}
	}, [value]);

	function handleChange(value: ValueType | null): void {
		const newValue = value ?? min;
		setInternalValue(newValue);
		onChange?.(newValue);
	}

	function handleOnIncrementClick(): void {
		handleChange(Math.min(internalValue + step, max));
	}

	function handleOnDecrementClick(): void {
		handleChange(Math.max(internalValue - step, min));
	}

	return (
		<S.Wrapper>
			<S.ValueInput
				min={min}
				max={max}
				step={step}
				value={internalValue}
				onChange={(e: any) => handleChange(e?.target?.value as number)}
				controls={false}
				stringMode={false}
				{...props}
			/>
			<S.Button onClick={handleOnDecrementClick} disabled={internalValue <= min}>
				-
			</S.Button>
			<S.Button onClick={handleOnIncrementClick} disabled={internalValue >= max}>
				+
			</S.Button>
		</S.Wrapper>
	);
}
